/*
* copied https://github.com/caasi/hooks/blob/master/src/use-blob.js
* */
import { useState, useEffect } from "react";

export enum ResultType {
  ARRAY_BUFFER = "arrayBuffer",
  BINARY_STRING = "binaryString",
  DATA_URL = "dataUrl",
  TEXT = "text",
}

function toMethodName(resultType: ResultType) {
  switch (resultType) {
    case ResultType.ARRAY_BUFFER: return "readAsArrayBuffer";
    case ResultType.BINARY_STRING: return "readAsBinaryString";
    case ResultType.DATA_URL: return "readAsDataURL";
    case ResultType.TEXT: return "readAsText";
    default: return "readAsArrayBuffer";
  }
}

export function useBlob(blob: Blob | undefined, resultType: ResultType = ResultType.ARRAY_BUFFER) {
  const [data, setData] = useState();

  useEffect(() => {
    if (!blob) {
      setData("error");
      return;
    }

    const reader = new FileReader();

    const handleOnLoad = () => {
      setData(reader.result);
      reader.removeEventListener("load", handleOnLoad);
    };

    reader.addEventListener("load", handleOnLoad);
    reader[toMethodName(resultType)](blob);

    return () => {
      reader.removeEventListener("load", handleOnLoad);
    };
  }, [blob, resultType]);

  return data;
}
